// extracted by mini-css-extract-plugin
export var aDayIn = "aDayin-module--a-day-in---YpQJ";
export var aDayInPhoto = "aDayin-module--a-day-in-photo--MwzBj";
export var gatsbyImageWrapper = "aDayin-module--gatsby-image-wrapper--6o5mi";